import { render, staticRenderFns } from "./View.left.vue?vue&type=template&id=01c260ac&scoped=true&"
import script from "./View.left.vue?vue&type=script&lang=js&"
export * from "./View.left.vue?vue&type=script&lang=js&"
import style0 from "./View.left.vue?vue&type=style&index=0&id=01c260ac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c260ac",
  null
  
)

export default component.exports